var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntersect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "intersect",
    width: 36.605,
    height: 36.605,
    viewBox: "0 0 36.605 36.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M14.013,12.94h9.652V1.072A1.073,1.073,0,0,0,22.592,0H1.072A1.073,1.073,0,0,0,0,1.072v21.52a1.073,1.073,0,0,0,1.072,1.072H12.94V14.013A1.073,1.073,0,0,1,14.013,12.94Z",
    fill: "#4e3057"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_745",
    "data-name": "Path 745",
    d: "M203.592,181H191.724v9.652a1.073,1.073,0,0,1-1.072,1.072H181v11.868a1.073,1.073,0,0,0,1.072,1.072h21.52a1.073,1.073,0,0,0,1.072-1.072v-21.52A1.073,1.073,0,0,0,203.592,181Z",
    transform: "translate(-168.06 -168.06)",
    fill: "#4e3057"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersect);
export default __webpack_public_path__ + "static/media/intersect.d56e29e435ad60eaed456588fdddc613.svg";
export { ForwardRef as ReactComponent };